module.exports = __webpack_public_path__ + "static/media/charity-white.6b66429c.webp";